module.exports = __webpack_public_path__ + "static/img/open-packet.509e372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/open-packet.png
// module id = /jO6
// module chunks = 215